import { ReorderTab } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReorderTab />;
}
